// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storeInfoContainer {
  /* padding: 30px; */
  max-width: 800px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  margin: 0 !important;
  padding: 0 !important;
}

.storeInfoHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
  width: 100%;
}

.pageTitle {
  font-size: 28px;
  font-weight: bold;
  margin: 0;
}

.edit-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 10px 15px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
  width: 170px !important;
  height: 50px;
  margin-left: auto;
}

.edit-button.save-mode {
  background-color: #ff6b00;
  color: white;
  border: none;
}

.edit-icon, .ok-icon {
  margin-right: 8px;
}

.ok-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  color: #ff6b00;
  width: 20px;
  height: 20px;
  border-radius: 2px;
  font-size: 12px;
  font-weight: bold;
}

.storeInfoContent {
  width: 100%;
  padding: 0;
  margin-left: 0;
  padding-left: 30px;
}

.infoField {
  margin-bottom: 20px;
}

.fieldLabel {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
  text-align: left;
}

.exampleText {
  font-size: 12px;
  color: #888;
  margin-top: -4px;
  margin-bottom: 8px;
}

.fieldValue {
  width: 400px;
  height: 50px;
  padding: 12px 15px;
  background-color: #f5f5f5;
  border-radius: 5px;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  box-sizing: border-box;
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  font-size: 16px;
  color: #666;
}

/* 편집 모드 입력 필드 스타일 추가 */
.fieldInput {
  width: 400px;
  height: 50px;
  padding: 12px 15px;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 5px;
  color: #333;
  font-size: 16px;
  box-sizing: border-box;
}

.fieldInput:focus {
  border-color: #FF8F45;
  outline: none;
}

/* 에러 메시지 스타일 */
.error {
  color: #e74c3c;
  padding: 20px;
  text-align: center;
  font-size: 16px;
} 

/* 주소 관련 스타일 추가 */
.addressInputContainer {
  width: 100%;
  position: relative;
}

.address-loading {
  margin-top: 5px;
  color: #666;
  font-size: 14px;
}

.address-error {
  margin-top: 5px;
  color: #f44336;
  font-size: 14px;
}

.coordinates-result {
  margin-top: 5px;
  color: #000;
  font-size: 14px;
}

.coordinates-result p {
  margin: 0;
} `, "",{"version":3,"sources":["webpack://./src/styles/StoreInfoManagement.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA,eAAe;AACf;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;AACX","sourcesContent":[".storeInfoContainer {\n  /* padding: 30px; */\n  max-width: 800px;\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n.storeInfoHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 40px;\n  width: 100%;\n}\n\n.pageTitle {\n  font-size: 28px;\n  font-weight: bold;\n  margin: 0;\n}\n\n.edit-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: white;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  padding: 10px 15px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.3s;\n  width: 170px !important;\n  height: 50px;\n  margin-left: auto;\n}\n\n.edit-button.save-mode {\n  background-color: #ff6b00;\n  color: white;\n  border: none;\n}\n\n.edit-icon, .ok-icon {\n  margin-right: 8px;\n}\n\n.ok-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background-color: white;\n  color: #ff6b00;\n  width: 20px;\n  height: 20px;\n  border-radius: 2px;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.storeInfoContent {\n  width: 100%;\n  padding: 0;\n  margin-left: 0;\n  padding-left: 30px;\n}\n\n.infoField {\n  margin-bottom: 20px;\n}\n\n.fieldLabel {\n  font-size: 15px;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 8px;\n  text-align: left;\n}\n\n.exampleText {\n  font-size: 12px;\n  color: #888;\n  margin-top: -4px;\n  margin-bottom: 8px;\n}\n\n.fieldValue {\n  width: 400px;\n  height: 50px;\n  padding: 12px 15px;\n  background-color: #f5f5f5;\n  border-radius: 5px;\n  color: #666;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  text-align: left;\n  box-sizing: border-box;\n}\n\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n  font-size: 16px;\n  color: #666;\n}\n\n/* 편집 모드 입력 필드 스타일 추가 */\n.fieldInput {\n  width: 400px;\n  height: 50px;\n  padding: 12px 15px;\n  background-color: white;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  color: #333;\n  font-size: 16px;\n  box-sizing: border-box;\n}\n\n.fieldInput:focus {\n  border-color: #FF8F45;\n  outline: none;\n}\n\n/* 에러 메시지 스타일 */\n.error {\n  color: #e74c3c;\n  padding: 20px;\n  text-align: center;\n  font-size: 16px;\n} \n\n/* 주소 관련 스타일 추가 */\n.addressInputContainer {\n  width: 100%;\n  position: relative;\n}\n\n.address-loading {\n  margin-top: 5px;\n  color: #666;\n  font-size: 14px;\n}\n\n.address-error {\n  margin-top: 5px;\n  color: #f44336;\n  font-size: 14px;\n}\n\n.coordinates-result {\n  margin-top: 5px;\n  color: #000;\n  font-size: 14px;\n}\n\n.coordinates-result p {\n  margin: 0;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
